import { render, staticRenderFns } from "./ManagementCertificateListRelations.vue?vue&type=template&id=05aa683a&"
import script from "./ManagementCertificateListRelations.vue?vue&type=script&lang=js&"
export * from "./ManagementCertificateListRelations.vue?vue&type=script&lang=js&"
import style0 from "./ManagementCertificateListRelations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports